import React from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import get from 'lodash/get'

import { load } from 'api'
import { Heading, HorizontalRule, Pagination } from 'core'
import { applyHOCs, paginationPageCount, paginationQueryBuilder } from 'helpers'
import { Grid, GridItem, Section, Spacer } from 'layout'
import { page } from 'page'

import { SpinnerIcon } from 'icons'

import GlobalSearch from './GlobalSearch'
import ResultList from './components/ResultList'
import ResultSingle from './components/ResultSingle'
import NoResultsFound from './components/NoResultsFound'
import css from './style.scss'

const REQUEST_LIMIT = 10
const SEMANTIC_REQUEST_LIMIT = 10

export const SearchResultsPage = (props) => {
  const { totalCount } = props.loadStatus.results
  const term = termSelector(props)
  const semanticLoadStatus = props.loadStatus.semanticWebinars || {}
  const semanticLoading = semanticLoadStatus.loading
  const semanticTotal = semanticLoadStatus.totalCount || 0
  const isLoading = props.loadStatus.results.loading || semanticLoading
  const hasSemanticResults = !semanticLoading && props.semanticWebinars && props.semanticWebinars.length > 0

  return (
    <Section>
      <Spacer size='sm' />
      <GlobalSearch />
      <Spacer size='xs' />
      <Heading size='h3' freight noMargin>
        {term ? `Search results for "${term}"` : 'Search results'}
      </Heading>
      <Spacer size='xs' />
      <HorizontalRule full />
      <Spacer size='sm' />

      {/* ── Loading state ── */}
      {isLoading && (
        <SpinnerIcon className={css.loadingSpinner} />
      )}

      {/* ── Results (shown only once both searches have resolved) ── */}
      {!isLoading && (
        <div>
          {/* ── Semantic search results ── */}
          {hasSemanticResults && (
            <div>
              <Grid>
                <GridItem col='1/4' mobile1of1>
                  <Heading size='h4' weight='light'>Related Webinars</Heading>
                </GridItem>
                <GridItem col='3/4' mobile1of1>
                  {
                    props.semanticWebinars.map((result, i) => (
                      <ResultSingle key={result.target_id} result={result} />
                    ))
                  }
                  <Pagination
                    pages={paginationPageCount(semanticTotal, SEMANTIC_REQUEST_LIMIT)}
                    pageParamKey='semanticPage'
                  />
                </GridItem>
              </Grid>
              <Spacer size='xs' />
              <HorizontalRule full />
              <Spacer size='sm' />
            </div>
          )}

          {/* ── Other Resources (keyword search results, webinars excluded by API) ── */}
          {
            props.results && props.results.length === 0 &&
            !(props.semanticWebinars && props.semanticWebinars.length > 0) &&
              <NoResultsFound />
          }
          {
            props.results && props.results.length > 0 &&
              <div>
                <Heading size='h4' weight='light'>Other Resources</Heading>
                <ResultList
                  results={props.results}
                  total={props.loadStatus.results.totalCount}
                  pages={paginationPageCount(totalCount, REQUEST_LIMIT)}
                />
              </div>
          }
        </div>
      )}

      <Spacer size='sm' />
    </Section>
  )
}

SearchResultsPage.propTypes = {
  results: React.PropTypes.array,
  semanticWebinars: React.PropTypes.array,
  loadStatus: React.PropTypes.object.isRequired
}

const mapStateToProps = (state, props) => ({}) // eslint-disable-line no-unused-vars

const termSelector = props => get(props, 'location.query.term')

export default applyHOCs([
  page(),
  connect(mapStateToProps),
  load({
    // ── Keyword search (full-text via PostgreSQL tsvector) ──
    results: {
      urlSelector: (state, props) => {
        const term = termSelector(props)
        const { page } = props.location.query

        if (!term) return null

        const query = {
          filters: {
            term
          }
        }

        return `/v2/search?${qs.stringify(paginationQueryBuilder(page, REQUEST_LIMIT, query))}`
      }
    },
    // ── Semantic search (pgvector cosine similarity, webinars only) ──
    semanticWebinars: {
      urlSelector: (state, props) => {
        const term = termSelector(props)
        if (!term) return null

        const semanticPage = parseInt(get(props, 'location.query.semanticPage'), 10) || 1
        const offset = (semanticPage - 1) * SEMANTIC_REQUEST_LIMIT

        return `/v2/webinars/semantic-search?q=${encodeURIComponent(term)}&limit=${SEMANTIC_REQUEST_LIMIT}&offset=${offset}`
      }
    }
  })
])(SearchResultsPage)
